import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  tabWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      maxWidth: 1044,

      [theme.breakpoints.down('tablet')]: {
        gap: '30px',
      },
      [theme.breakpoints.up('tablet')]: {
        padding: SPACES.xs,

        gap: '40px',
      },
    },
  },

  //* Invoices table
  invoicesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  invoicesHeadCell: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,

      color: theme.palette.custom.grey2,
    },
  },
  invoiceRow: {
    '&&': {
      '&:last-child td, &:last-child th': {
        border: 0,
      },
    },
  },
  invoiceBodyCell: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  inoviceAmountStatus: {
    marginLeft: SPACES.xs,

    display: 'inline-block',
    padding: `1px ${SPACES.xs}`,

    borderRadius: 2,
  },
  invoiceAmountStatusSuccess: {
    backgroundColor: theme.palette.custom.primary,
  },
  invoiceAmountStatusFailure: {
    backgroundColor: theme.palette.custom.warning2,
  },
  invoiceStatus: {
    margin: 0,
    color: theme.palette.custom.white,
    textTransform: 'capitalize',
  },
  invoiceLink: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.4,
      textTransform: 'none',

      '&:disabled': {
        color: theme.palette.custom.grey2,
      },
    },
  },
  subscriptionEndText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.4,
    },
  },

  //* Invoices list
  seeIcon: {
    '&&': {
      width: 20,
      height: 'auto',
      fill: theme.palette.custom.white,
    },
  },
  invoicesList: {
    margin: 0,
    padding: 0,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxxl,

    listStyle: 'none',
  },
  invoiceListItem: {
    display: 'flex',
  },
  invoiceListItemInner: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  invoiceTitleWrapper: {
    minWidth: 140,
  },
  invoiceListTitle: {
    margin: 0,
    alignSelf: 'center',

    fontWeight: FONTS.WEIGHTS.medium,
    fontSize: FONTS.SIZES.xl,
    lineHeight: 1.4,

    color: theme.palette.custom.darkBlue2,
  },
  invoiceListDate: {
    margin: 0,
    fontSize: FONTS.SIZES.s,
    lineHeight: 1.33,

    color: theme.palette.custom.darkBlue2,
  },
  invoiceListBtns: {
    marginLeft: 'auto',

    display: 'flex',
    gap: SPACES.xxxs,
  },
  invoiceIcon: {
    '&&': {
      alignSelf: 'center',

      backgroundColor: theme.palette.custom.primary,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '20px',
      width: 30,
      height: 30,

      '&:hover, &:focus': {
        backgroundColor: theme.palette.custom.primary,
      },

      '&.Mui-disabled': {
        '&&': {
          backgroundColor: theme.palette.custom.darkBlue2,
        },
      },
    },
  },
}))

export { useStyles }
